import React from 'react';
import PropTypes from 'prop-types';
import { render } from "react-dom";
import GravityForm from "../../../lib/react-gravity-form";

class VincitSurvey extends React.Component {

  render() {
    return (
      <div>
      <GravityForm
        backendUrl={this.props.url}
        formID={this.props.formid}
        form={this.props.form}
      />
      </div>
    );
  }
}
VincitSurvey.propTypes = {
  formid: PropTypes.string.isRequired,
};

export default VincitSurvey;